<template>
    <div class="widget">
        <slot name="widget-header"></slot>
        <slot name="widget-body"></slot>
    </div>
</template>